
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "grid": "grid-d06bffdf",
    "nowrap": "nowrap-d06bffdf",
    "fit-width": "fit-width-d06bffdf",
    "fit-height": "fit-height-d06bffdf",
    "fit-both": "fit-both-d06bffdf",
    "fitWidth": "fit-width-d06bffdf",
    "fitHeight": "fit-height-d06bffdf",
    "fitBoth": "fit-both-d06bffdf"
};
exports.styleSource = ".grid-d06bffdf{position:relative;display:grid}.nowrap-d06bffdf>*{white-space:nowrap}.fit-width-d06bffdf{width:100%}.fit-height-d06bffdf{height:100%}.fit-both-d06bffdf{width:100%;height:100%}";
exports.default = exports.styles;
            
module.moduleType = "style";
